import { Lock, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';

interface Props {
  message: string;
}

export function SystemLockScreen({ message }: Props) {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-background via-background to-destructive/10 p-4">
      <Card className="max-w-lg w-full border-destructive/30 shadow-xl">
        <CardContent className="pt-10 pb-8 text-center space-y-6">
          <div className="mx-auto h-20 w-20 rounded-full bg-destructive/10 flex items-center justify-center">
            <Lock className="h-10 w-10 text-destructive" />
          </div>
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">Acesso bloqueado</h1>
            <p className="text-sm text-muted-foreground uppercase tracking-wider">
              Bloqueio de licença
            </p>
          </div>
          <p className="text-base text-foreground/90 whitespace-pre-line">
            {message}
          </p>
          <div className="pt-4">
            <Button variant="outline" onClick={signOut} className="gap-2">
              <LogOut className="h-4 w-4" />
              Sair
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}